"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const UI_1 = require("~/components/UI");
const consts_1 = require("~/consts/consts");
const utils_1 = require("~/utils/utils");
const PreconfiguredFramesButton_scss_1 = __importDefault(require("./PreconfiguredFramesButton.scss"));
function PreconfiguredFramesButton({ imageURI = consts_1.itemPlaceholderSrc, label, onClick = () => ({}), }) {
    const clickHandler = () => {
        onClick();
    };
    const button = (react_1.default.createElement("button", { type: "button", className: PreconfiguredFramesButton_scss_1.default.tile, key: `${label}`, onClick: clickHandler },
        react_1.default.createElement(UI_1.Image, { className: PreconfiguredFramesButton_scss_1.default.image, src: (0, utils_1.formatAssetsURL)(imageURI) }),
        label ? react_1.default.createElement("div", { className: PreconfiguredFramesButton_scss_1.default.label }, label) : null));
    return react_1.default.createElement("div", null, button);
}
exports.default = PreconfiguredFramesButton;
